import {putMethod} from '~/api'

async function put(orderId, request) {
    return await putMethod(`/api/order/${orderId}/message`, request)
}

export {put}
